export default import.meta.ROLLDOWN_FILE_URL_K9VkEM9wROOizOg3VfnMIg